<template>
  <BaseModal v-model="model" :max-width="600">
    <div class="upgrade-modal__content">
      <h3 class="upgrade-modal__title">{{ t('global.upgradeToProTailorTitle') }}</h3>
      <p class="upgrade-modal__description">{{ t('global.upgradeToProTailorDescription') }}</p>
      
      <div class="upgrade-modal__available-container">
        <UpgradeButton />
        <p class="upgrade-modal__available">{{ t('global.upgradeToProTailorAvailable') }}</p>
      </div>
      
      <div class="upgrade-modal__video">
        <iframe
          width="100%"
          height="315"
          src="https://www.youtube.com/embed/0ldPSbTE-j4?autoplay=1"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </BaseModal>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
import { useStore } from 'vuex';
import BaseModal from '@/components/BaseModal.vue';
import UpgradeButton from '@/features/Header/components/UpgradeButton.vue';

const store = useStore();
const { t } = useI18n();

const model = computed({
  get: () => store.state.upgradeToProModal,
  set: (val) => {
    store.commit('SET_STATE_PROPERTY', {
      property: 'upgradeToProModal',
      value: val,
    });
  },
});
</script>

<style lang="scss" scoped>
.upgrade-modal {
  &__content {
    margin-top: 10px;
    margin-bottom: 24px;
  }

  &__title {
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 16px;
    color: #1a1a1a;
  }

  &__description {
    font-size: 14px;
    line-height: 1.5;
    margin-bottom: 16px;
    color: #666;
  }

  &__available-container {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }

  &__available {
    font-size: 14px;
    font-weight: 600;
    color: #007bff;
    margin: 0 0 0 8px;
  }

  &__video {
    margin-top: 16px;
    margin-bottom: 16px;
    border-radius: 8px;
    overflow: hidden;
    
    iframe {
      border-radius: 8px;
    }
  }
}
</style>
